import League from "./gamingPartials/league";
import Runescape from "./gamingPartials/runescape";
import VideoGames from "./gamingPartials/videoGames";
import BoardGames from "./gamingPartials/boardGames";

function Gaming() {

    return (
        <>
            <div className="container">

                <div className="index-banner">
                    <div className="index-welcome-text">
                        I am mostly a PC gamer. The username I use online for most of my accounts is:
                    </div>
                    <div className="index-welcome-banner">
                        Chippy Cheese
                    </div>

                    <div className="index-cards">
                        <div className="row">
                            <League />
                            <div className="mt-5 col-12 col-md-4">
                                <div className="full-height align-center">
                                    <div className="p-3 grey-3 index-card-background-full">
                                        <BoardGames />
                                        <VideoGames />
                                    </div>
                                </div>
                            </div>
                            <Runescape />
                        </div>
                    </div>
                </div>
            </div>
        </>);
}

export default Gaming;
